import React from 'react';

const WorkshopSkeleton = () => {
  return (
    <div className="wk-grid">
      {[1, 2, 3].map((idx) => (
        <div key={idx} className="wk-card wk-card-skeleton">
          <div className="wk-skel-line wk-skel-sm" />
          <div className="wk-skel-line wk-skel-lg" />
          <div className="wk-skel-line" />
          <div className="wk-skel-line" />
        </div>
      ))}
    </div>
  );
};

export default WorkshopSkeleton;
